import { render, staticRenderFns } from "./SummaryWorkSimplified.vue?vue&type=template&id=cdda02ec&scoped=true&"
import script from "./SummaryWorkSimplified.vue?vue&type=script&lang=js&"
export * from "./SummaryWorkSimplified.vue?vue&type=script&lang=js&"
import style0 from "./SummaryWorkSimplified.vue?vue&type=style&index=0&id=cdda02ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdda02ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemTitle,VMenu})
